import { useEffect, useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import "./Categorias.css";
 const API = process.env.REACT_APP_API_URL


export default function Categorias() {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "null");
  const navigate = useNavigate();
  const [datos, setDatos] = useState([]);
  const [loading, setLoading] = useState(true);


  const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch( API + "/user/refresh",{
         method:"POST",
          credentials: "include"
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        window.location.reload();
        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };


  const traerDatos = async () => {
    try {
      const response = await fetch( API + "/categorias/traerCategorias",{
      });
      const data = await response.json();
      const formateados = (data.datos || []).map(c => ({
        ...c,
        estadoCategoria: c.estadoCategoria || "ACTIVO" 
      }));
      setDatos(formateados);
    } catch (error) {
      console.error("Error trayendo categorías:", error);
    } finally {
      setLoading(false);
    }
  };

  const ActualizarEstado = async (id, nuevoEstado) => {
  try {
    const res = await fetch(
      `${API}/categorias/ActualizarEstadoCategoria/${id}/${nuevoEstado}`,
      {
        method: "PUT",
      }
    );

    if(res.status === 403 && await renovarToken()) return;

    if (!res.ok) {
      throw new Error("Error al actualizar el estado");
    }

    alert("Estado actualizado correctamente ✅");
    traerDatos();

  } catch (error) {
    console.error(error);
    alert("Error al actualizar el estado");
  }
};

  useEffect(() => {
    traerDatos();
  }, []);

  return (
    <div className="categorias-page">
      <header className="cat-navbar">
        <div className="container nav-content">
          <div className="brand" onClick={() => navigate("/")}>
            <span className="brand-logo">M</span>
            <span className="brand-text">MundoShop</span>
          </div>
          <nav className="nav-actions">
            <NavLink to="/" className="nav-link-item">Inicio</NavLink>
            {user?.rol === "ROLE_ADMIN" && (
              <NavLink to="/AgregarCategorias" className="btn-admin-pill">
                <span>+</span> Nueva Categoría
              </NavLink>
            )}
          </nav>
        </div>
      </header>

      <section className="cat-hero">
        <div className="container">
          <h1 className="hero-title">Nuestras Colecciones</h1>
          <p className="hero-subtitle">
            Explora una selección curada de productos diseñada para tu estilo de vida.
          </p>
        </div>
      </section>

      <main className="container main-content">
        {loading ? (
          <div className="loader-container">
            <div className="spinner"></div>
            <p>Cargando categorías...</p>
          </div>
        ) : (
          <div className="cat-grid">
            {datos.length > 0 ? (
              datos.map((cat) => (
                <article key={cat.id} className="cat-card">
                  <div className="cat-card-body">
                    <div className="cat-header-row">
                      <div className="cat-icon-box">
                        <span className="cat-emoji">📂</span>
                      </div>
                      {cat.estadoCategoria === "INACTIVO" && <span className="badge-inactive">Inactivo</span>}
                    </div>
                    
                    <h2 className="cat-name">{cat.nombre}</h2>
                    <p className="cat-description">
                      {cat.descripcion || "Descubre productos exclusivos en esta categoría."}
                    </p>
                    
                    <button
                      className="cat-btn-action"
                      onClick={() => navigate(`/CategoriaProductos/${cat.id}`)}
                    >
                      Explorar Ahora
                      <span className="arrow">→</span>
                    </button>
                  </div>

                  {user?.rol === "ROLE_ADMIN" && (
                    <div className="admin-zone">
                      <div className="admin-status-info">
                        <p>Estado actual: <strong>{cat.estadoCategoria}</strong></p>
                      </div>
                      
                      <select
                        className="admin-select-status"
                        value={cat.estadoCategoria}
                        onChange={(e) => {
                          const nuevoEstado = e.target.value;
                          setDatos(prev =>
                            prev.map(c =>
                              c.id === cat.id ? { ...c, estadoCategoria: nuevoEstado } : c
                            )
                          );
                        }}
                      >
                        <option value="ACTIVO">ACTIVO</option>
                        <option value="INACTIVO">INACTIVO</option>
                      </select>

                      <div className="admin-btns-row">
                        <button
                          className="btn-admin edit"
                          onClick={() => navigate(`/EditarCategoria/${cat.id}`)}
                        >
                          ✏️ Editar Categoría
                        </button>
                        
                        <button
                          className="btn-admin save-status"
                          onClick={() => ActualizarEstado(cat.id, cat.estadoCategoria)}
                        >
                          💾 Guardar estado
                        </button>
                      </div>
                    </div>
                  )}
                </article>
              ))
            ) : (
              <div className="no-data">
                <p>No se encontraron categorías disponibles.</p>
              </div>
            )}
          </div>
        )}
      </main>

      <footer className="cat-footer">
        <p>© 2026 Mundo Shop · Calidad y Confianza</p>
      </footer>
    </div>
  );
}